import router from './router'
import store from './store'
import {Message} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getToken} from '@/utils/auth'
import RouteState from "@/store/modules/route"; // get token from cookie

NProgress.configure({showSpinner: false}) // NProgress Configuration

const whiteList = ['/', '/test', '/speed','/order','/message','/designer'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
    NProgress.start()
    const hasToken = getToken()


    if (hasToken) {


        if (store.state.user.route.length <= 7) {
            store.state.user.route = RouteState.state.WhiteRoute.concat(RouteState.state.LoginRoute)
            router.addRoutes(store.state.user.route)
            next(`/`)
        }


        const hasGetUserInfo = store.getters.username
        if (hasGetUserInfo) {

            next()
            NProgress.done()
        } else {
            try {
                // get user info
                await store.dispatch('user/getInfo')

                next()
                NProgress.done()
            } catch (error) {
                // remove token and go to login page to re-login
                await store.dispatch('user/resetToken')
                Message.error(error || 'Has Error')
                next(`/`)
                NProgress.done()
            }

        }


    } else {
        // store.state.user.route=RouteState.state.WhiteRoute

        if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next()
            NProgress.done()
        } else {
            // other pages that do not have permission to access are redirected to the login page.
            next(`/`)
            NProgress.done()
        }

    }


})
